"use strict";

var isFunction = require("../function/is");

var classRe = /^\s*class[\s{/}]/, functionToString = Function.prototype.toString;

module.exports = function (value) {
	if (!isFunction(value)) return false;
	if (classRe.test(functionToString.call(value))) return false;
	return true;
};



//////////////////
// WEBPACK FOOTER
// ./~/type/plain-function/is.js
// module id = 500
// module chunks = 27